import { useEffect, useMemo, useState } from 'react';
import { TimeSlot } from '../../../state/infiniteCalendarSeries';
import { DayPart, SESSION_SIZE } from '../types';
import {
    getDefaultActiveTab,
    getOverallDiscount,
    getSessionsGroupedByTimeOfDay,
    getTabForSessionId,
} from './utils';

export const useTab = (
    timeSlotData: TimeSlot[],
    timezone: string,
    selectedSessionId: string | undefined,
) => {
    const sessionsByDurationAndTimeOfDay = useMemo(
        () => getSessionsGroupedByTimeOfDay(timeSlotData, timezone),
        [timeSlotData, timezone],
    );
    const [activeTab, setActiveTab] = useState<keyof DayPart>();

    useEffect(() => {
        if (timeSlotData.length < SESSION_SIZE) {
            return;
        }
        setActiveTab(
            selectedSessionId
                ? getTabForSessionId(selectedSessionId, timeSlotData, timezone)
                : getDefaultActiveTab(sessionsByDurationAndTimeOfDay),
        );
    }, [
        timeSlotData,
        timezone,
        selectedSessionId,
        sessionsByDurationAndTimeOfDay,
    ]);

    return {
        activeTab,
        overallDiscount: getOverallDiscount(timeSlotData),
        sessionsByDurationAndTimeOfDay,
        setActiveTab,
    };
};
